import React, { useRef } from 'react'
import classNames from 'classnames'
import { Chip as StChip, CHIP_TYPES } from '@st-operations/uikit/src/v2/index'

import './styles.scss'

const Chip = ({ value, onRemove, selected, onSelect }) => {
  const ref = useRef(null)

  return (
    <div ref={ref} onClick={() => onSelect?.(value)}>
      <StChip
        small
        className={classNames('uup-chips__chip', { 'uup-chips__chip--selected': selected })}
        value={
          <div className="uup-chips__chip-content">
            <div>{value}</div>
          </div>
        }
        onClick={(_, e) => {
          e.stopPropagation()
          onRemove?.(value)
        }}
        type={CHIP_TYPES.OUTLINED}
      />
    </div>
  )
}

export default Chip
